import React from 'react';

import { Snackbar } from '../../../components/atoms';
import * as Api from '../../../weborder/Api';

type Props = {
  isDeliveryOrder: boolean;
  isOutsideDeliveryZone: boolean;
  restaurantData: Api.CollectionRestaurantDetail | Api.DeliveryRestaurantDetail;
  translate: any;
};

export function NotAvailableWarning(props: Props): JSX.Element | null {
  const { isDeliveryOrder, isOutsideDeliveryZone, restaurantData, translate } =
    props;

  if (!isDeliveryOrder && restaurantData.IsOpen) {
    return null;
  }

  if (isDeliveryOrder && !isOutsideDeliveryZone && restaurantData.IsOpen) {
    return null;
  }

  if (isDeliveryOrder && isOutsideDeliveryZone) {
    const cannotDeliver = translate('Cannot_deliver', {
      restaurantName: restaurantData.RestaurantName,
    });
    const doesntDeliver = translate('Does_not_deliver');

    return (
      <Snackbar
        message={`${cannotDeliver}. ${doesntDeliver}`}
        severity="warning"
      />
    );
  }

  const preOrder = restaurantData.AcceptPreOrders
    ? `- ${translate('Preorder_only')}`
    : '';
  const isClosed = `${translate('Is_closed', {
    restaurantName: restaurantData.RestaurantName,
  })} ${preOrder}`;
  const openTimeMessage = restaurantData.OpenTimeMessage
    ? `. ${restaurantData.OpenTimeMessage}`
    : '';

  return (
    <Snackbar message={`${isClosed}${openTimeMessage}`} severity="warning" />
  );
}
